const LoaderCircle=({isAlwaysDarkMode})=>{
    return(
        <span id="alim-loader-circle" className={`alim-pre-loader animate-spin ${isAlwaysDarkMode==="1"?"border-white border-b-transparent":""}`}></span>
    )
}

export default LoaderCircle